import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    Typography,
    Button,
} from "@mui/material";
import ModalCloseButton from "../../components/UI/ModalCloseButton";
import {
    modalBackdropProps,
    MODAL_PAPER_SX,
} from "../../utils/styles/modal.overlay";

const messageSx = {
    fontFamily: "Poppins",
    fontSize: "14px",
    color: "var(--primary-text-color)",
    marginBottom: "20px",
    marginTop: "12px",
};

const primaryBtnSx = {
    padding: "6px 16px",
    backgroundColor: "var(--primary-theme-color)",
    color: "var(--primary-button-text-color)",
    borderRadius: "4px",
    textTransform: "none",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    minWidth: "100px",
};

const outlineBtnSx = {
    ...primaryBtnSx,
    backgroundColor: "transparent",
    color: "var(--primary-theme-color)",
    border: "2px solid var(--primary-theme-color)",
};

function DeleteModal({ open, onClose, onConfirm }) {
    const [isDeleted, setIsDeleted] = useState(false);

    useEffect(() => {
        if (!open) {
            setIsDeleted(false);
        }
    }, [open]);

    const handleConfirm = async () => {
        await onConfirm();
        setIsDeleted(true);
    };

    const handleClose = () => {
        setIsDeleted(false);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            BackdropProps={modalBackdropProps}
            PaperProps={{
                sx: {
                    ...MODAL_PAPER_SX,
                    borderRadius: "4px",
                    padding: "20px",
                    width: "320px",
                    textAlign: "center",
                    position: "relative",
                },
            }}
        >
            <ModalCloseButton onClick={handleClose} />

            {isDeleted ? (
                <>
                    <Typography sx={messageSx}>
                        The report has been deleted
                    </Typography>
                    <DialogContent sx={{ padding: 0 }}>
                        <Button onClick={handleClose} sx={primaryBtnSx}>
                            Close
                        </Button>
                    </DialogContent>
                </>
            ) : (
                <>
                    <Typography sx={messageSx}>
                        Are you sure to delete the report?
                    </Typography>
                    <DialogContent sx={{ padding: 0 }}>
                        <div
                            style={{
                                display: "flex",
                                gap: "12px",
                                justifyContent: "center",
                            }}
                        >
                            <Button onClick={handleConfirm} sx={outlineBtnSx}>
                                Yes, delete
                            </Button>
                            <Button onClick={handleClose} sx={primaryBtnSx}>
                                No, keep it
                            </Button>
                        </div>
                    </DialogContent>
                </>
            )}
        </Dialog>
    );
}

export default DeleteModal;
